// import MobileDetect from 'mobile-detect'


export const md = new MobileDetect(window.navigator.userAgent)
export const isMobile = md.mobile()
export const isPhone = md.phone()
export const isAndroidOS = md.os() === 'AndroidOS'

// var md = new MobileDetect(window.navigator.userAgent)
// var isPhone = md.phone()
export const iPhone = md.phone() === 'iPhone'
export const ios = md.os() === 'iOS'
export const isMobileDevice = md.mobile()
export const isTablet = md.tablet()

window.isMobile = isMobile